ManageIQ.angular.app.component('widgetError', {
  template: `
    <div class="blank-slate-pf" style="padding: 10px">
      <div class="blank-slate-pf-icon">
        <i class="fa fa-cog"></i>
      </div>
      <h1>
        ${__('Error: Request for data failed.')}
      </h1>
    </div>
  `,
});
